import DayOfWeek from '../enums/days-of-week-types';

class OfficeNotification {
  id?: string;

  officeId = '';

  textEnglish? = '';

  textDutch = '';

  scheduledDateTime: Date = new Date();

  expirationDate?: Date;

  isRecurring = false;

  recurringDays: DayOfWeek[] = [];
}

export default OfficeNotification;
